import PromotionsCounter from 'src/common/PromotionsCounter/PromotionsCounter';

export const MENU_ITEMS_WITH_COUNTER = ['Promotions'];

export const MENU_ITEM_COUNTER_COMPONENT = {
  Promotions: PromotionsCounter,
};
